import api from "./base";

/**
 * Fetches the list of payment methods (credit cards) for the current user.
 * @returns {Promise<PaymentMethodDetails[]>}
 */
export async function fetchPaymentMethods() {
    const res = await api.get("/payments/cards");
    return res.data;
}

/**
 * Initiates adding a new credit card by calling the add card endpoint.
 * @param {string} name - Full name for the credit card
 * @param {string} phoneNumber - Phone number for the credit card
 * @returns {Promise<{success: boolean, url: string}>}
 */
export async function addPaymentMethod(name, phoneNumber) {
    const res = await api.post("/teacher/subscription/cards/add", {
        name,
        phoneNumber,
    });
    return res.data;
}

/**
 * Sets a card as the default payment method.
 * @param {number} cardId - The ID of the card to set as default
 * @returns {Promise<Object>}
 */
export async function setDefaultCard(cardId) {
    const res = await api.post("/payments/cards/setDefault", {
        cardId,
    });
    return res.data;
}

/**
 * Edits a card's name.
 * @param {number} cardId - The ID of the card to edit
 * @param {string} name - The new name for the card
 * @returns {Promise<Object>}
 */
export async function editCardName(cardId, name) {
    const res = await api.post("/payments/cards/edit", {
        cardId,
        name,
    });
    return res.data;
}

/**
 * Fetches subscription price information.
 * @returns {Promise<{price: number, nextChargeDate: string}>}
 */
export async function fetchSubscriptionPrice() {
    const res = await api.get("/teacher/subscription/price");
    return res.data;
}

/**
 * Deletes a payment method (credit card).
 * @param {number} cardId - The ID of the card to delete
 * @returns {Promise<Object>}
 */
export async function deletePaymentMethod(cardId) {
    const res = await api.delete("/payments/cards/delete", {
        data: { cardId },
    });
    return res.data;
}

/**
 * Fetches the list of subscription invoices for the current teacher.
 * @returns {Promise<Invoice[]>}
 */
export async function fetchSubscriptionInvoices() {
    const res = await api.get("/teacher/subscription/invoices");
    return res.data;
}

// TypeScript interface for reference (not used in JS):
// interface PaymentMethodDetails {
//   id: number;
//   name: string;
//   lastDigits: string;
//   createdAt: Date;
//   updatedAt: Date;
//   type: CreditCardType;
//   isDefault: boolean;
// } 